import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React from "react";
import { createRoot } from "react-dom/client";

import { config } from "@krea/shared/config";
import { initSentryOptions } from "@krea/shared/utils/initSentry";

import { HttpService } from "./httpService";
import "./i18n"; // Initialize i18n

import Layout from "./layout";
import { queryClient } from "./store/queryClient";

const isNotDevEnvironment = config.isSentryEnabled;

Sentry.init({
  ...initSentryOptions(config),
  dsn: "https://a2f62445ec59440aabafa1c08b002188@o242905.ingest.sentry.io/5222570",
});

const instance = HttpService.getInstance();
instance.setupInterceptors();

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Layout />
      {!isNotDevEnvironment && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>,
);
